<template>
    <v-card tile class="weather-page mx-auto" max-width="95%" elevation="0">
        <v-list-item two-line class="weather-report-header px-2">
            <v-list-item-content>
                <v-list-item-title class="weather-report-title text-h6 white--text pt-6">
                    Your weather report, captain
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Last update on {{ currentTime }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-card-text class="px-2 pt-0">
            <!--<v-row>
            <v-col cols="5">
                <v-divider class="mt-3" style="border-color: white; margin-left: 65%;"></v-divider>
            </v-col>
            <v-col cols="2" class="d-flex justify-center">
                <v-span class="white--text font-weight-bold text-center">Today</v-span>
            </v-col>
            <v-col cols="5">
                <v-divider class="mt-3" style="border-color: white; margin-right: 65%;"></v-divider>
            </v-col>
        </v-row>-->
            <v-row class="mt-0">
                <v-col class="weather-section-title white--text font-weight-bold px-3 pt-0" cols="12">
                    Current weather
                </v-col>
            </v-row>

            <v-row class="mt-0" justify="space-between" align="center">
                <v-spacer></v-spacer>
                <v-col cols="5" class="d-flex justify-center py-0">
                    <v-img contain class="tempImage" max-width="90px" max-height="54px" src="@/assets/img/thermometer.png"></v-img>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="5" class="d-flex justify-center py-0">
                    <v-img class="weatherImage" max-width="90px" max-height="90px" :src="iconurl"></v-img>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <v-row justify="space-between" align="center" class="pt-1 mt-0">
                <v-spacer></v-spacer>
                <v-col cols="5" class="d-flex justify-center pt-0">
                    <span class="weather-current-value white--text">{{ temperature }}</span>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="5" class="d-flex justify-center pt-0">
                    <span class="weather-current-value white--text">{{ weatherDescriptionText }}</span>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <v-row justify="center" align="center" class="weather-stats mt-0 pt-2">
                <v-col cols="12" class="white--text text-center feels-like">
                    Feels like {{ feelsLike }}
                </v-col>
            </v-row>

            <v-row justify="space-between" align="center" class="weather-stats mt-0 pt-2">
                <v-spacer></v-spacer>
                <v-col cols="5" class="d-flex justify-center">
                    <v-icon color="white">mdi-windsock</v-icon>
                    <span class="white--text ml-2">{{windDeg}} {{windSpeed}} </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5" class="d-flex justify-center">
                    <v-icon color="white">mdi-water-percent</v-icon>
                    <span class="white--text ml-2">{{ humidity }}</span>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <!--<v-row>
            <v-col cols="5">
                <v-divider class="mt-3" style="border-color: white; margin-left: 65%;"></v-divider>
            </v-col>
            <v-col cols="2" class="d-flex justify-center">
                <v-span class="white--text font-weight-bold text-center">Forecast</v-span>
            </v-col>
            <v-col cols="5">
                <v-divider class="mt-3" style="border-color: white; margin-right: 65%;"></v-divider>
            </v-col>
        </v-row>-->

            <h2 class="weather-forecast-divider">Forecast</h2>

            <v-list class="weather-forecast-list transparent mt-0 pt-2">
                <v-subheader class="weather-forecast-header px-0">
                    <v-row>
                        <v-col cols="5">
                            <v-row>
                                <v-col class="white--text font-weight-bold px-0" cols="12">Day of the week</v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                                <v-col class="white--text font-weight-bold text-right pl-1 pr-0" cols="2">Rain</v-col>
                                <v-col class="white--text font-weight-bold text-right pl-2 pr-3" cols="6">Wind</v-col>
                                <v-col class="white--text font-weight-bold text-right px-0" cols="4">Day / Night</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-subheader>

                <v-list-item v-for="item in forecast" :key="item.day" class="weather-forecast-item px-0">
                    <v-row class="fill-height" align="center">

                        <v-col cols="5">
                            <v-row class="align-center">
                                <v-col class="white--text caption px-0" cols="5">{{ item.day }}</v-col>
                                <v-col class="px-0" cols="2">
                                    <v-img max-height="36px" max-width="28px" width="28px" height="36px" :src="item.icon"></v-img>
                                </v-col>
                                <v-col class="white--text text-center caption px-0" cols="5">{{ item.description }}</v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="7">
                            <v-row class="align-center">
                                <v-col class="text-right white--text caption pl-1 pr-0" cols="2">
                                    {{ item.rain }}
                                </v-col>

                                <v-col cols="6">
                                    <v-row class="pl-2 pr-3">
                                        <v-col class="text-right white--text caption pl-0 pr-0" cols="5">
                                            {{ item.windDeg }}
                                        </v-col>

                                        <v-col class="text-right white--text caption pl-0 pr-0" cols="7">
                                            {{ item.windSpeed }}
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col class="text-right white--text caption px-0" cols="4">
                                    {{ item.temp }}
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-list-item>
            </v-list>

            <v-row class="weather-note" justify="space-between" align="center">
                <v-spacer></v-spacer>
                <v-col cols="2" class="d-flex justify-center align-center">
                    <v-icon color="white">mdi-information</v-icon>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="white--text text-center info-location">
                    Weather forecast according to current boat position
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="2" class="d-flex justify-center align-center">
                    <v-icon color="white">mdi-information</v-icon>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

        </v-card-text>
        <v-overlay :value="isLoading" opacity="0.9" z-index="1000">
            <v-row align="center" justify="center" class="fill-height">
                <v-col cols="12" class="text-center white--text">
                    <v-progress-circular indeterminate size="50" color="white"></v-progress-circular>
                    <div class="mt-4 font-weight-bold">{{ loadingLabel }}</div>
                </v-col>
            </v-row>
        </v-overlay>

    </v-card>
</template>

<script lang="ts">
    import {
        computed,
        defineComponent,
        onBeforeUnmount,
        onMounted,
        ref,
        watch
    } from "vue";
    import useWeather from "@/store/services/weather.service";
    import { alarm } from "@/store";
    import { ILocationFromParticle } from "@/models/AlarmStatus";
    import { WeatherModel } from "@/models/WeatherModel";
    export default defineComponent({
        setup() {
            const isLoading = ref(false);
            const loadingLabel = ref("Fetching weather data...");
            const { getCurrentWeather } = useWeather();
            const currentWeather = ref<WeatherModel>(null);
            let weatherUpdateTimeoutId: ReturnType<typeof setTimeout> | null = null;
            let isActive = true;

            const clearWeatherUpdateTimeout = () => {
                if (weatherUpdateTimeoutId) {
                    clearTimeout(weatherUpdateTimeoutId);
                    weatherUpdateTimeoutId = null;
                }
            };

            function timeConverter(UNIX_timestamp) {
                var a = new Date(UNIX_timestamp * 1000);
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                var day = days[a.getDay()];
                var hour = a.getHours().toString().padStart(2, "0");
                var min = a.getMinutes().toString().padStart(2, "0");
                var time = day + ', ' + hour + ':' + min;
                return time;
            }

            function timetoDayConverter(UNIX_timestamp) {
                var a = new Date(UNIX_timestamp * 1000);
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return days[a.getDay()];
            }

            function getCardinalDirection(angle) {
                // Added the VS15 using the Unicode escape sequence to not use Emoji
                const directions = [
                    'N \u2B06\uFE0E',
                    'NE \u2197\uFE0E',
                    'E \u27A1\uFE0E',
                    'SE \u2198\uFE0E',
                    'S \u2B07\uFE0E',
                    'SW \u2199\uFE0E',
                    'W \u2B05\uFE0E',
                    'NW \u2196\uFE0E'
                ];
                // Added the VS15 using the Unicode escape sequence to use Emoji
                const emoji_directions = [
                    'N \u2B06\uFE0F',
                    'NE \u2197\uFE0F',
                    'E \u27A1\uFE0F',
                    'SE \u2198\uFE0F',
                    'S \u2B07\uFE0F',
                    'SW \u2199\uFE0F',
                    'W \u2B05\uFE0F',
                    'NW \u2196\uFE0F'
                ];
                return emoji_directions[Math.round(angle / 45) % 8];
            }

            const forecast = computed<object>(() => {
                let comingWeather = [];
                if (currentWeather.value) {
                    for (var i = 0; i < 7; i++) {
                        let day = timetoDayConverter(currentWeather.value.daily[i].dt);
                        let icon = require(`@/assets/wicons/${currentWeather.value.daily[i].weather[0].icon}@2x.svg`);
                        let temp = Math.round(currentWeather.value.daily[i].temp.day).toString().trim() + "°C / " + Math.round(currentWeather.value.daily[i].temp.night).toString().trim() + "°C";
                        let rain = (currentWeather.value.daily[i].pop * 100).toFixed(0) + "%";
                        let description = currentWeather.value.daily[i].weather[0].description.charAt(0).toUpperCase() + currentWeather.value.daily[i].weather[0].description.slice(1);
                        let windSpeed = currentWeather.value.daily[i].wind_speed.toString().trim() + "m/s";
                        let windDeg = getCardinalDirection(currentWeather.value.daily[i].wind_deg);
                        let dayWeather = { day, icon, temp, rain, windSpeed, windDeg, description };
                        comingWeather.push(dayWeather);
                    }
                }
                return comingWeather;
            });

            const currentTime = computed<string>(() => {
                return currentWeather.value ? timeConverter(currentWeather.value.current.dt) : "";
            });

            const temperature = computed<string>(() => {
                return currentWeather.value ? Math.round(currentWeather.value.current.temp).toString().trim() + "°C" : "";
            });
            const feelsLike = computed<string>(() => {
                return currentWeather.value ? Math.round(currentWeather.value.current.feels_like).toString().trim() + "°C" : "";
            });
            const humidity = computed<string>(() => {
                return currentWeather.value ? currentWeather.value.current.humidity.toString().trim() + "%" : "";
            });
            const windSpeed = computed<string>(() => {
                return currentWeather.value ? currentWeather.value.current.wind_speed.toString().trim() + "m/s" : "";
            });
            const windDeg = computed<string>(() => {
                return currentWeather.value ? getCardinalDirection(currentWeather.value.current.wind_deg) : "";
            });

            const weatherMainText = computed<string>(() => {
                return currentWeather.value ? currentWeather.value.current.weather[0].main.toString().trim() : "";
            });

            const weatherDescriptionText = computed<string>(() => {
                if (currentWeather.value) {
                    const mainWeather = currentWeather.value.current.weather[0].description.toString().trim();
                    return mainWeather.charAt(0).toUpperCase() + mainWeather.slice(1);
                } else {
                    return "";
                }
            });

            const iconurl = computed(() => {
                if (currentWeather.value) {
                    return require(`@/assets/wicons/${currentWeather.value.current.weather[0].icon}@2x.svg`);
                } else {
                    return "";
                }
            });
            const location = computed<ILocationFromParticle | null>(() => {
                return alarm.lastKnownLocation ? alarm.lastKnownLocation : null;
            });
            const getWeather = (gps: ILocationFromParticle | null) => {
                isLoading.value = true;
                const lat = gps ? gps.location.geometry.coordinates[1].toString() : "0";
                const lon = gps ? gps.location.geometry.coordinates[0].toString() : "0";

                const startTime = Date.now();

                getCurrentWeather(lat, lon).then((result: WeatherModel) => {
                    if (!isActive) {
                        return;
                    }

                    const elapsed = Date.now() - startTime;
                    const delay = Math.max(0, 500 - elapsed);

                    clearWeatherUpdateTimeout();
                    weatherUpdateTimeoutId = setTimeout(() => {
                        if (!isActive) {
                            return;
                        }

                        currentWeather.value = result;
                        isLoading.value = false;
                        weatherUpdateTimeoutId = null;
                    }, delay);
                });
            };

            watch(() => location.value, getWeather);
            onMounted(() => {
                getWeather(location.value);
            });
            onBeforeUnmount(() => {
                isActive = false;
                clearWeatherUpdateTimeout();
            });
            return {
                forecast,
                currentTime,
                temperature,
                feelsLike,
                humidity,
                windSpeed,
                windDeg,
                weatherMainText,
                weatherDescriptionText,
                iconurl,
                loadingLabel,
                isLoading
            };
        }
    });
</script>
<style lang="scss" scoped>
    .weather-report-header {
        min-height: 64px;
    }

    .weather-report-title {
        padding-top: 20px !important;
        font-size: var(--app-font-title);
        line-height: 1.2;
    }

    .weather-section-title {
        font-size: var(--app-font-body);
        line-height: 1.2;
    }

    .weather-current-value {
        font-size: var(--app-font-emphasis);
        line-height: 1.15;
    }

    .weather-stats {
        font-size: var(--app-font-body);
        line-height: 1.2;
    }

    .weather-stats ::v-deep .v-icon {
        font-size: 20px !important;
    }

    .weather-forecast-header {
        height: 32px;
        min-height: 32px;
        padding-top: 0;
        padding-bottom: 0;
        font-size: var(--app-font-small);
        line-height: 1.2;
    }

    .weather-forecast-divider {
        display: flex;
        width: 64%;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin: 16px auto 0;
        color: rgba(255, 255, 255, 0.72);
        font-size: var(--app-font-caption);
        font-weight: 600;
        letter-spacing: 0.08em;
        line-height: 1.2;
        text-align: center;
        text-transform: uppercase;
    }

    .weather-forecast-divider::before,
    .weather-forecast-divider::after {
        height: 1px;
        flex: 1 1 auto;
        background: rgba(255, 255, 255, 0.28);
        content: "";
    }

    .weather-forecast-item {
        min-height: 40px;
    }

    .weather-forecast-item ::v-deep .v-col {
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .weather-forecast-item ::v-deep .caption {
        font-size: var(--app-font-caption) !important;
    }

    .weather-note {
        font-size: var(--app-font-caption);
        line-height: 1.2;
    }

    .feels-like {
        font-size: var(--app-font-body);
    }

    .forecast-text {
        font-size: var(--app-font-small);
    }

    .info-location {
        font-size: var(--app-font-caption);
    }

    .tempImage {
        width: 60%;
    }

    .weatherImage {
        width: 100%;
    }

    .weather {
        padding-right: 0;

        .v-list-item__content {
        }

        .weather_icon {
            padding-bottom: 110%;
        }

        .weather_action {
            margin-top: 0;
            margin-bottom: 0;
            margin-left: 0 !important;
            width: 20%;
        }

        .weather_title {
            max-width: 265px;
        }
    }
</style>